import React from 'react';
import {
  Card,
  Highlight,
  IconBannersWarning,
  LinkText,
  ListItem,
  LoadingSpinner,
  SectionHeader,
  VStack,
} from '@adc/parallax-component-library';
import { useQuery } from '@tanstack/react-query';
import { useNavigate, useLocation } from 'react-router';
import { systemAboutQueryOptions } from '../../queryOptions';
import { ROUTES } from '../../constants';
import i18n from '../../utilities/i18n';

export default function About() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasPreviousPage =
    location.key !== 'default' && window.history.length > 1;

  const about = useQuery(systemAboutQueryOptions());

  const handleReturn = () => {
    return hasPreviousPage ? navigate(-1) : navigate(ROUTES.ROOT);
  };

  return (
    <VStack gap="$4" alignItems="center" flex={1} margin="auto">
      {about.isError ? (
        <Highlight
          variant="danger"
          iconStart={
            <IconBannersWarning
              color="$neutral.0"
              accentColor="$support.danger.default"
            />
          }
          title={i18n.t('Page_About.load_error_title')}
          body={i18n.t('Page_About.load_error')}
          testID="about-error-banner"
        />
      ) : null}

      {about.isPending ? (
        <VStack alignItems="center" justifyContent="center" flexGrow={1}>
          <LoadingSpinner testID="about-loading" />
        </VStack>
      ) : null}

      {about.isSuccess ? (
        <VStack minWidth="50%">
          <Card>
            <SectionHeader
              label={i18n.t('Page_About.title')}
              testID="about-title"
            />
            {Object.entries(about.data || {}).map(([key, value]) => {
              return (
                <ListItem
                  key={key}
                  title={key}
                  label={value}
                  testID={`about-listitem-${key}`}
                />
              );
            })}
          </Card>
        </VStack>
      ) : null}

      <VStack>
        <LinkText
          onPress={handleReturn}
          type="$bodyBase.default"
          testID="about-return-link"
        >
          {i18n.t(
            hasPreviousPage ? 'Common.returnPrevious' : 'Common.returnHome',
          )}
        </LinkText>
      </VStack>
    </VStack>
  );
}
